module.exports = __webpack_public_path__ + "fonts/yesterday-font.c37644d.woff2";